import Layout1 from '@/layout/Layout1'

export default [{
  path: '/humanresource',
  component: Layout1,
  children: [{
    path: 'unit/:id',
    component: () => import('@/components/humanresource/maintenance/units/unitEdit')
  }, {
    path: 'unit',
    component: () => import('@/components/humanresource/maintenance/units/unitList')
  }, {
    path: 'department/:id',
    component: () => import('@/components/humanresource/maintenance/departments/departmentEdit')
  }, {
    path: 'department',
    component: () => import('@/components/humanresource/maintenance/departments/departmentList')
  }, {
    path: 'employee/:id',
    component: () => import('@/components/humanresource/maintenance/employees/employeeEdit')
  }, {
    path: 'employee',
    component: () => import('@/components/humanresource/maintenance/employees/employeeList')
  }]
  // children: [{
  //   path: 'mnregionEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/regions/regionEdit')
  // }, {
  //   path: 'mnregionList',
  //   component: () => import('@/components/humanresource/maintenance/regions/regionList')
  // }, {
  //   path: 'mnprovinceEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/provinces/provinceEdit')
  // }, {
  //   path: 'mnprovinceList',
  //   component: () => import('@/components/humanresource/maintenance/provinces/provinceList')
  // }, {
  //   path: 'mncityEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/cities/cityEdit')
  // }, {
  //   path: 'mncityList',
  //   component: () => import('@/components/humanresource/maintenance/cities/cityList')
  // }, {
  //   path: 'mnbarangayEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/barangays/barangayEdit')
  // }, {
  //   path: 'mnbarangayList',
  //   component: () => import('@/components/humanresource/maintenance/barangays/barangayList')
  // }, {
  //   path: 'mnreligionEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/religions/religionEdit')
  // }, {
  //   path: 'mnreligionList',
  //   component: () => import('@/components/humanresource/maintenance/religions/religionList')
  // }, {
  //   path: 'mnpositionEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/positions/positionEdit')
  // }, {
  //   path: 'mnpositionList',
  //   component: () => import('@/components/humanresource/maintenance/positions/positionList')
  // }, {
  //   path: 'mnapplicationdocumentEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/applicationdocuments/applicationdocumentEdit')
  // }, {
  //   path: 'mnapplicationdocumentList',
  //   component: () => import('@/components/humanresource/maintenance/applicationdocuments/applicationdocumentList')
  // }, {
  //   path: 'mnessayquestionEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/essayquestions/essayquestionEdit')
  // }, {
  //   path: 'mnessayquestionList',
  //   component: () => import('@/components/humanresource/maintenance/essayquestions/essayquestionList')
  // }, {
  //   path: 'mnotherquestionEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/otherquestions/otherquestionEdit')
  // }, {
  //   path: 'mnotherquestionList',
  //   component: () => import('@/components/humanresource/maintenance/otherquestions/otherquestionList')
  // }, {
  //   path: 'mnhealthquestionEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/healthquestions/healthquestionEdit')
  // }, {
  //   path: 'mnhealthquestionList',
  //   component: () => import('@/components/humanresource/maintenance/healthquestions/healthquestionList')
  // }, {
  //   path: 'mnpositionEdit/:id',
  //   component: () => import('@/components/humanresource/maintenance/positions/positionEdit')
  // }, {
  //   path: 'mnpositionList',
  //   component: () => import('@/components/humanresource/maintenance/positions/positionList')
  // }]
}]
